export default __webpack_public_path__ + "static/media/4.947f8e17.jpeg";